import { create } from 'zustand';
import type { Theme } from '@/shared/types/common.types';

function applyThemeToDOM(theme: Theme): void {
  const root = document.documentElement;
  root.classList.remove('light', 'dark');

  if (theme === 'system') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    root.classList.add(prefersDark ? 'dark' : 'light');
  } else {
    root.classList.add(theme);
  }
}

// Apply system theme on store initialization
applyThemeToDOM('system');

interface UIState {
  sidebarCollapsed: boolean;
  mobileSidebarOpen: boolean;
  theme: Theme;
  activeModal: string | null;

  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleMobileSidebar: () => void;
  setMobileSidebarOpen: (open: boolean) => void;
  setTheme: (theme: Theme) => void;
  openModal: (modalName: string) => void;
  closeModal: () => void;
  reset: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: false,
  mobileSidebarOpen: false,
  theme: 'system',
  activeModal: null,

  toggleSidebar: () => {
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed }));
  },

  setSidebarCollapsed: (sidebarCollapsed) => { set({ sidebarCollapsed }); },

  toggleMobileSidebar: () => {
    set((state) => ({ mobileSidebarOpen: !state.mobileSidebarOpen }));
  },

  setMobileSidebarOpen: (mobileSidebarOpen) => { set({ mobileSidebarOpen }); },

  setTheme: (theme) => {
    set({ theme });
    applyThemeToDOM(theme);
  },

  openModal: (activeModal) => { set({ activeModal }); },
  closeModal: () => { set({ activeModal: null }); },

  reset: () => {
    set({
      sidebarCollapsed: false,
      mobileSidebarOpen: false,
      theme: 'system',
      activeModal: null,
    });
  },
}));
